import { OrderIdentifierColumnType } from "@api/graphql/generated/generated-types";
import { useAuth } from "@src/common/hooks/useAuth";

// The courier setting that picks which order number the dispatcher sees:
// the internal order ID or the customer-facing tracking number.
export function useOrderIdentifierColumnType(): OrderIdentifierColumnType {
  const { courier } = useAuth();
  return (
    courier?.courier?.orderIdentifierColumnType ??
    OrderIdentifierColumnType.OrderId
  );
}
